// File: frontend/src/pages/InvestorPitch/configs/CustomerInsurersConfig.js

import React from 'react';
import * as Slides from '../slides';

export const getCustomerInsurersSlides = (t) => [
  {
    id: 'intro',
    title: t('investor_pitch.intro_insurers.intro.title'),
    content: <Slides.IntroSlideInsurers />
  },
  {
    id: 'allegory-description',
    title: t('investor_pitch.allegory_description.intro.title'),
    content: <Slides.AllegoryDescriptionSlide />
  },
  {
    id: 'omnichannel-experience',
    title: t('investor_pitch.omnichannel_experience.intro.title'),
    content: <Slides.OmnichannelExperienceSlide />
  },
  {
    id: 'insurance-process',
    title: t('investor_pitch.insurance_process.intro.title'),
    content: <Slides.InsuranceProcessSlide />
  },
  {
    id: 'data-points',
    title: t('investor_pitch.data_points.intro.title'),
    content: <Slides.DataPointsSlide />
  },
  {
    id: 'insurance-case-study',
    title: t('investor_pitch.insurance_case_study.intro.title'),
    content: <Slides.InsuranceCaseStudySlide />
  },
  {
    id: 'operational-model',
    title: t('investor_pitch.operational_model.intro.title'),
    content: <Slides.OperationalModelSlide />
  },
  {
    id: 'ai-impact-categories',
    title: t('investor_pitch.ai_impact.intro.title'),
    content: <Slides.AIImpactCategoriesSlide />
  },
  {
    id: 'waterfall-cta',
    title: t('investor_pitch.waterfall_cta.intro.title'),
    content: <Slides.WaterfallCTASlide />
  },
  {
    id: 'pilot-project-1',
    title: t('investor_pitch.pilot1.intro.title'),
    content: <Slides.PilotProjectSlide1 />
  },
  {
    id: 'pilot-project-2',
    title: t('investor_pitch.pilot2.intro.title'),
    content: <Slides.PilotProjectSlide2 />
  },
  {
    id: 'pilot-project-3',
    title: t('investor_pitch.pilot3.intro.title'),
    content: <Slides.PilotProjectSlide3 />
  },
  //
  {
    id: 'security',
    title: t('investor_pitch.slides.security.title'),
    content: <Slides.SecuritySlide />
  },
  {
    id: 'research',
    title: t('investor_pitch.slides.research.title'),
    content: <Slides.ScientificArticlesSlide />
  },
  {
    id: 'standard-closing',
    title: t('investor_pitch.slides.standard_closing.title'),
    content: <Slides.ClosingSlide />
  }
];